module.exports = __webpack_public_path__ + "static/media/Avtar.540244a8.svg";